module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.3"},{"quantity":0.03,"color":"#91E3AD","label":"0.3 - 0.85"},{"quantity":0.06,"color":"#DEFFB0","label":"0.85 - 1.46"},{"quantity":0.01,"color":"#FFE68C","label":"1.46 - 2.34"},{"quantity":9,"color":"#FF9982","label":"2.34 - 3.7"},{"quantity":12,"color":"#FF4D30","label":"3.7 - 4.93"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_rice.json
// module id = Pmqg
// module chunks = 171